import { render } from "./select-hours.vue?vue&type=template&id=23ac04be&ts=true"
import script from "./select-hours.vue?vue&type=script&lang=ts"
export * from "./select-hours.vue?vue&type=script&lang=ts"

import "./select-hours.vue?vue&type=style&index=0&id=23ac04be&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__